<template>
  <v-card class="py-2 mx-auto" min-width="100" :max-width="MAX_CONTENT_WIDTH">
    <h1 class="page-title">Saved For Later</h1>
    <v-divider></v-divider>
    <div class="d-flex justify-end">
      <!-- TODO: Add a sort button-->
      <!-- TODO: Make a reusable component-->
      <div class="filter-wrapper"
        ><select-dense
          v-model="filter"
          :items="mediumFilters"
          item-text="label"
          item-value="value"
          @change="filterReviews"
        ></select-dense>
      </div>
    </div>
    <v-divider></v-divider>
    <!-- TODO: Add a message if no items exist-->
    <page-selection v-if="totalPages > 1" :total-pages="totalPages" v-model="page"></page-selection>
    <div class="saved-for-later-entries justify-center">
      <div v-for="item in savedForLaterResults.items" :key="item.work.id" class="entry">
        <div class="blurred-poster-wrapper">
          <posterBlurredMargins
            :src="item.work.posterSource"
            :to="{ path: '/work/' + item.work.medium + '/' + item.work.id }"
            rounded
            :aspect="getAspectRatio(item.work.medium)"
            :max-height="150"
            vertical
          >
            <medium-icon :medium="item.work.medium" :size="24" class="ml-1 mt-1"></medium-icon>

            <v-menu offset-y transition="slide-y-transition">
              <template #activator="{ on, attrs }">
                <button v-bind="attrs" v-on="on" class="utility">
                  <v-icon dark>mdi-dots-horizontal</v-icon>
                </button>
              </template>
              <v-list class="utility-menu saved-for-later-action-menu" dense>
                <v-list-item @click="removeSavedForLater(item.work.id, item.work.medium)">
                  <v-icon class="mr-1">mdi-bookmark-off</v-icon>
                  <v-list-item-content>Remove</v-list-item-content>
                </v-list-item>
                <!-- TODO: Add action to toggle engaged-->
                <!-- <v-list-item>
                  <v-icon class="mr-1">mdi-eye</v-icon>
                  <v-list-item-content>Mark as seen</v-list-item-content>
                </v-list-item> -->
                <v-list-item :to="{ name: 'rate', query: { medium: item.work.medium, workID: item.work.id } }">
                  <v-icon class="mr-1">mdi-file-document-edit</v-icon>
                  <v-list-item-content>New review</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-icon class="mr-1">mdi-close</v-icon>
                  <v-list-item-content>Cancel</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </posterBlurredMargins>
        </div>

        <router-link :to="{ path: '/work/' + item.work.medium + '/' + item.work.id }">
          <p class="work-title">
            {{ item.work.title }}
          </p>
        </router-link>
        <p class="subtext">{{ subtext(item.work) }}</p>
      </div>
    </div>
    <page-selection v-if="totalPages > 1" :total-pages="totalPages" v-model="page"></page-selection>
  </v-card>
</template>

<script>
import { mapMutations } from "vuex";
// Util
import getAspectRatio from "../util/getAspectRatio";
import { MAX_CONTENT_WIDTH } from "../util/constants.js";
import { formatDate } from "../util/dateHelpers.js";
// Components
import posterBlurredMargins from "../components/poster-blurred-margins.vue";
import mediumIcon from "../components/medium-icon.vue";
import pageSelection from "../components/page-selection.vue";
import SelectDense from "../components/select-dense.vue";
// Mixins
import WatchlistAndSeen from "@/mixins/watchlistAndSeen";
import { mediums } from "../util/enums.js";
import { userFriendlyMediumWord } from "../util/mediumHelpers.js";

const mediumFilters = [];
for (const medium of Object.values(mediums)) {
  mediumFilters.push({
    label: userFriendlyMediumWord(medium),
    value: medium,
  });
}

export default {
  name: "saved-for-later",

  components: { posterBlurredMargins, mediumIcon, pageSelection, SelectDense },
  mixins: [WatchlistAndSeen],

  data: () => ({
    MAX_CONTENT_WIDTH,
    mediumFilters,

    userId: null,

    filter: null,

    ITEMS_PER_PAGE: 50,
    page: 1,

    savedForLaterResults: {
      totalCount: null,
      items: [],
    },

    COLUMN_WIDTH: 100,
  }),

  computed: {
    totalPages() {
      return this.savedForLaterResults.totalCount
        ? Math.ceil(this.savedForLaterResults.totalCount / this.ITEMS_PER_PAGE)
        : 1;
    },
  },

  async mounted() {
    const response = await this.$axios.get("/profile", {
      params: {
        user: this.$route.params.username,
      },
    });
    this.userId = response.data.id;
    await this.getSavedForLater();
  },

  watch: {
    page() {
      this.getSavedForLater();
    },
  },

  methods: {
    ...mapMutations["showSnackbar"],
    getAspectRatio,

    getSavedForLater: async function () {
      const response = await this.$axios.get("/v1/saved-for-later", {
        params: {
          userId: this.userId,
          offset: this.ITEMS_PER_PAGE * (this.page - 1),
          limit: this.ITEMS_PER_PAGE,
          medium: this.filter ? this.filter : undefined,
        },
      });
      this.savedForLaterResults.totalCount = response.data.totalCount;
      this.savedForLaterResults.items = response.data.items;
    },

    subtext(work) {
      switch (work.medium) {
        case this.$mediums.FILM:
        case this.$mediums.TV_SHOW:
          return formatDate(work.releaseDate);
        case this.$mediums.PODCAST:
        case this.$mediums.ALBUM:
        case this.$mediums.BOOK:
          return work.creators[0].name;
        default:
          return null;
      }
    },

    async removeSavedForLater(workId, medium) {
      try {
        await this.removeFromWatchlist(workId, medium, false);
        const removedItemIdx = this.savedForLaterResults.items.findIndex((item) => item.work.id === workId);
        this.savedForLaterResults.items.splice(removedItemIdx, 1);

        if (this.page < this.totalPages) {
          // Minus 1 to account for the item that was just removed
          const replacementItemIdx = this.page * this.ITEMS_PER_PAGE - 1;
          const replacementItemResponse = await this.$axios.get("/v1/saved-for-later", {
            params: {
              userId: this.userId,
              offset: replacementItemIdx,
              limit: 1,
            },
          });
          this.savedForLaterResults.totalCount = replacementItemResponse.data.totalCount;
          this.savedForLaterResults.items = this.savedForLaterResults.items.concat(replacementItemResponse.data.items);
        } else {
          // This needs to be updated after the check for page in case there is only 1 item on the following page.
          this.savedForLaterResults.totalCount -= 1;
        }
      } catch (err) {
        console.error(err);
        this.showSnackbar({
          text: "An error has occurred",
          error: true,
        });
      }
    },

    async filterReviews() {
      this.page = 1;
      this.savedForLaterResults.items = [];
      this.savedForLaterResults.totalCount = null;

      await this.getSavedForLater();
    },
  },
};
</script>

<style scoped>
.saved-for-later-entries {
  margin: 8px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 100px);
  gap: 16px;
  justify-items: center;
}
.saved-for-later-entries .entry {
  width: 100px;
}
.saved-for-later-entries .entry .blurred-poster-wrapper {
  height: 150px;
}
.saved-for-later-entries .entry .blurred-poster-wrapper button.utility {
  position: absolute;
  top: 4px;
  right: 4px;

  height: 24px;
  width: 24px;

  display: block;
  border-radius: 100%;
  background-color: var(--semi-opaque-overlay-bg-color);
}
.saved-for-later-entries .entry .blurred-poster-wrapper button.utility .v-icon {
  vertical-align: baseline;
}
.saved-for-later-entries .entry p {
  margin-bottom: 0;
  font-size: 12px;
  line-height: 14px;
}
.saved-for-later-entries .entry p.work-title {
  font-weight: bold;
  color: var(--v-primary-base);
}
.saved-for-later-entries .entry .subtext {
  font-weight: normal;
  color: var(--text-middle-lightness);
}
</style>
